module.exports = __webpack_public_path__ + "img/Bouclier07.da7c1deb.png";